import { __assign, __spreadArrays } from "tslib";
import * as React from 'react';
import { SortableList } from '../../primitives/sortable-list';
import { namespacedClassnames } from '../../common';
import { SortableInputListItem } from '../sortable-input-list-item';
import { Text, Button, LibColor } from '../../new-libby';
import { compKey } from './key';
import { iconsMap } from '../../icons/processed';
import { Icon } from '../../primitives/icon/icon';
import { Popover } from '../../primitives/popover/popover';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { Toggle } from '../../primitives/toggle/toggle';
export var sortableInputListKey = 'sortable-input-list';
export var SortableInputList = function (props) {
    var _a, _b, _c, _d;
    var _e = React.useState(false), isDeleteListPopoverOpen = _e[0], setDeleteListPopoverOpen = _e[1];
    var classNames = namespacedClassnames(sortableInputListKey, props.className);
    var reorderItems = function (positionData) {
        var currentItems = Array.from(props.items);
        currentItems.splice(positionData.newIndex, 0, currentItems.splice(positionData.oldIndex, 1)[0]);
        props.onReorderItems({ updatedItems: currentItems, positionData: positionData });
        props.onSelectListItem(positionData.newIndex);
    };
    var onChangeListItem = function (idx) { return function (newValue) {
        var newListItems = props.items.map(function (oldItem, existingIdx) {
            return idx === existingIdx ? __assign(__assign({}, oldItem), { value: newValue }) : oldItem;
        });
        props.onChangeTextItem({ updatedItems: newListItems });
    }; };
    var onDeleteListItem = function (deletedIdx) { return function () {
        var filteredItems = props.items.filter(function (_, itemIdx) { return itemIdx !== deletedIdx; });
        props.onDeleteItem({ updatedItems: filteredItems, deletedIdx: deletedIdx });
    }; };
    var onSelectListItem = function (idx) { return function () {
        props.onSelectListItem(idx);
    }; };
    var onAddNewListItem = function () {
        var currentItems = __spreadArrays(props.items, [{ value: '' }]);
        props.onAddItem({ updatedItems: currentItems });
    };
    var onDeleteList = function () {
        if (props.deleteListData) {
            props.deleteListData.onDelete();
        }
    };
    var togglePopover = function () { return setDeleteListPopoverOpen(!isDeleteListPopoverOpen); };
    var renderPopoverBody = (React.createElement("span", { className: namespacedClassnames(compKey + "-popover-body") },
        React.createElement(Text, { type: 'hnm' }, (_a = props.deleteListData) === null || _a === void 0 ? void 0 : _a.deleteConfirmData.title),
        React.createElement(Text, { className: 'description', color: 't30' }, (_b = props.deleteListData) === null || _b === void 0 ? void 0 : _b.deleteConfirmData.description),
        React.createElement("div", { className: 'buttons-container' },
            React.createElement(Button, { className: compKey + "-cancel-item-btn", type: 'secondary', onClick: togglePopover }, props.t('common.cancel')),
            React.createElement(Button, { className: compKey + "-confirm-remove-btn", intent: 'danger', onClick: onDeleteList }, props.t('common.libby.delete-list')))));
    var isRemoveListButtonDisalbed = (_c = props.deleteListData) === null || _c === void 0 ? void 0 : _c.disabledTooltipInfo;
    var removeIcon = React.createElement(Icon, { color: isRemoveListButtonDisalbed ? LibColor.grey100 : undefined, icon: iconsMap.remove });
    var removeListButton = function () {
        return (React.createElement("div", { className: compKey + "-remove-list-button " + (isRemoveListButtonDisalbed ? 'disabled' : null), onClick: isRemoveListButtonDisalbed ? undefined : togglePopover },
            React.createElement(Tooltip, { body: isRemoveListButtonDisalbed || '', forceHidden: !isRemoveListButtonDisalbed, relativeToBody: true }, removeIcon)));
    };
    var removeListButtonContainer = (React.createElement(Popover, { body: renderPopoverBody, isOpen: isDeleteListPopoverOpen, onOuterAction: togglePopover, className: namespacedClassnames(compKey + "-popover") }, removeListButton()));
    var toggleItemButton = function () {
        var _a = props.toggleListData, onToggle = _a.onToggle, toggled = _a.toggled, disabled = _a.disabled;
        var onChange = function (_, e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            onToggle();
        };
        return React.createElement(Toggle, { value: toggled, onChange: onChange, disabled: disabled, size: 'xsmall' });
    };
    var toggleOrRemoveButton = props.toggleListData ? toggleItemButton() :
        ((_d = props.deleteListData) === null || _d === void 0 ? void 0 : _d.onDelete) ? removeListButtonContainer : null;
    var listHeader = (React.createElement("div", { className: compKey + "-header" },
        typeof props.texts.title === 'string' || !props.texts.title ?
            React.createElement(Text, { className: compKey + "-title", html: props.texts.title || '' }) :
            React.createElement(Text, { className: compKey + "-title" }, props.texts.title),
        toggleOrRemoveButton));
    var addBtnClassnames = namespacedClassnames(compKey + "-add-item-btn-container", { disabled: props.texts.addOptionError });
    var addListItemButtonContainer = (React.createElement("div", { className: addBtnClassnames },
        React.createElement(Button, { type: 'tertiary', onClick: onAddNewListItem, disabled: props.texts.addOptionError },
            React.createElement(Icon, { icon: iconsMap.plusWithBgSmall }),
            props.t('common.libby.add-option'))));
    var sortableListInputItems = props.items.map(function (item, idx) {
        var _a;
        var removeDisabled = (_a = item.deleteItemConfirmData) === null || _a === void 0 ? void 0 : _a.disabledItemTooltipInfo;
        return (React.createElement(SortableInputListItem, { value: item.value, errorData: { currentValueError: item.currentValueError, innerValuesError: item.innerValuesError }, isSelected: props.selectedIndex === idx, isFocused: item.isFocused, disabled: item.disabled, toggleData: item.toggleData, onAddNewLevel: item.onAdd, isAddNewLevelDisabled: item.isAddDisabled, deleteItemData: item.deleteItemConfirmData, onChange: onChangeListItem(idx), onDelete: onDeleteListItem(idx), onSelect: onSelectListItem(idx), removeDisabled: removeDisabled, placeholder: props.texts.placeholder, addItemTextInfo: props.texts.addItemTextInfo, isDragReorderItemDisabled: props.isDragReorderItemsDisabled, title: item.title, t: props.t, key: idx }));
    });
    var sortableItemList = (React.createElement(SortableList, { items: sortableListInputItems, onSortEnd: reorderItems, useDragHandle: true, itemKeys: props.items.map(function (_, idx) { return idx; }) }));
    return (React.createElement("div", { className: classNames },
        listHeader,
        sortableItemList,
        addListItemButtonContainer));
};
//# sourceMappingURL=index.js.map